import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormMessage } from '~/components/ui/form';
import { Label } from '~/components/ui/label';
import { Input } from '~/components/ui/input';

interface AddressFormFieldProps {
  label: string;
  placeholder: string;
  fieldName?: string;
}

export const AddressFormField = ({ label, placeholder, fieldName = 'address' }: AddressFormFieldProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={fieldName}
      render={({ field }) => (
        <FormItem className="flex flex-col gap-2">
          <Label className="text-white font-bold text-sm">{label}</Label>
          <div className="relative">
            <Input
              className="bg-white/5 border border-white/20 rounded-[64px] px-5 py-4 text-white placeholder:text-white/50 font-bold text-base focus:border-white/40 focus:ring-0 focus:outline-none h-14"
              placeholder={placeholder}
              {...field}
            />
          </div>
          <FormMessage className="text-red-400 text-sm ml-5" />
        </FormItem>
      )}
    />
  );
};
